import { ReactComponent as Package } from '../../assets/icons/package.svg'
import { ReactComponent as Path } from '../../assets/icons/path.svg'
import { ReactComponent as Notepad } from '../../assets/icons/notepad.svg'
import { ReactComponent as Question } from '../../assets/icons/question.svg'
import { ReactComponent as Printer } from '../../assets/icons/printer.svg'
import { ReactComponent as Home } from '../../assets/icons/home.svg'
import { ReactComponent as MassRecording } from '../../assets/icons/massRecording.svg'
import { ReactComponent as Agenda } from '../../assets/icons/agenda.svg'
import { ReactComponent as Report } from '../../assets/icons/report.svg'

import * as routes from '../../routes'

const MENU_ITEMS = [
  {
    title: 'action:go-to-home',
    Icon: Home,
    path: routes.HOME.linkTo(),
  },
  {
    title: 'action:request-shipment',
    Icon: Package,
    path: routes.SHIPPING_SEND.linkTo(),
  },
  {
    title: 'action:import-file',
    Icon: MassRecording,
    path: routes.SHIPPINGS_RECORDING.linkTo(),
    allowedUserCodes: ['45135', '40574', '40236', '40193', '90132']
  },
  // {
  //   title: 'action:request-shipment',
  //   Icon: Package,
  //   path: routes.SHIPPING_SEND.linkTo(),
  //   elements: [
  //     {
  //       title: 'action:one-shipment',
  //       Icon: Package,
  //       path: routes.SHIPPING_SEND.linkTo(),
  //     },
  //     {
  //       title: 'action:import-file',
  //       Icon: MassRecording,
  //       path: routes.SHIPPINGS_RECORDING.linkTo(),
  //       allowedUserCodes: ['45135', '40574', '40236', '40193', '90132']
  //     },
  //   ],
  // },
  {
    title: 'noun:tracking',
    Icon: Path,
    path: routes.SHIPPINGS_TRACKING.linkTo(),
  },
  {
    title: 'noun:billing',
    Icon: Notepad,
    path: routes.BILLING.linkTo(),
    requiredPermission: 'isFinancial',
  },
  {
    title: 'noun:reports',
    Icon: Report,
    path: routes.REPORTS.linkTo(),
    requiredPermission: 'isMaster',
  },
  {
    title: 'noun:my-agenda',
    Icon: Agenda,
    path: routes.AGENDA.linkTo(),
  },
  {
    title: 'noun:print-settings',
    Icon: Printer,
    path: routes.PRINT_SETTINGS.linkTo(),
    extraClass: 'navItemPrinter',
  },
  {
    title: 'noun:help-support',
    Icon: Question,
    path: routes.HELP.linkTo(),
    extraClass: 'navItemHelp',
  },
]

export default MENU_ITEMS
